let TenantName = /*#__PURE__*/function (TenantName) {
  TenantName["PACKLINK"] = "PACKLINK";
  TenantName["PACKLINKES"] = "PACKLINKES";
  TenantName["PACKLINKIT"] = "PACKLINKIT";
  TenantName["PACKLINKPRO"] = "PACKLINKPRO";
  TenantName["PACKLINKPROES"] = "PACKLINKPROES";
  TenantName["PACKLINKPROFR"] = "PACKLINKPROFR";
  TenantName["PACKLINKPROIT"] = "PACKLINKPROIT";
  TenantName["PACKLINKPRODE"] = "PACKLINKPRODE";
  TenantName["CORREOSES"] = "CORREOSES";
  TenantName["EBAYES"] = "EBAYES";
  TenantName["EBAYIT"] = "EBAYIT";
  TenantName["EBAYFR"] = "EBAYFR";
  TenantName["EBAYGB"] = "EBAYGB";
  TenantName["EBAYIE"] = "EBAYIE";
  TenantName["EBAYDE"] = "EBAYDE";
  TenantName["EBAYAT"] = "EBAYAT";
  TenantName["EBAYBE"] = "EBAYBE";
  TenantName["EBAYNL"] = "EBAYNL";
  TenantName["DPDCBEUN"] = "DPDCBEUN";
  TenantName["DPDBBEUN"] = "DPDBBEUN";
  TenantName["PAYPALES"] = "PAYPALES";
  TenantName["PAYPALFR"] = "PAYPALFR";
  TenantName["PAYPALIT"] = "PAYPALIT";
  TenantName["PAYPALPT"] = "PAYPALPT";
  TenantName["PAYPALDE"] = "PAYPALDE";
  TenantName["PAYPALBE"] = "PAYPALBE";
  TenantName["PAYPALIE"] = "PAYPALIE";
  TenantName["PAYPALAT"] = "PAYPALAT";
  TenantName["PAYPALNL"] = "PAYPALNL";
  TenantName["PAYPALGB"] = "PAYPALGB";
  return TenantName;
}({});

export { TenantName };
//# sourceMappingURL=TenantName.js.map
